import React, { useEffect, useState } from 'react';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { useTheme } from '@mui/material/styles';
import { Stack, Box, Paper, LinearProgress } from '@mui/material';
import HeaderPage from './HeaderPage';
import List from './List';
import utils from 'components/utils';

const KitUsers = props => {
	const theme = useTheme();
	const translate = utils.useI18N();
	const iCan = utils.usePermissions();
	const availableDepots = utils.useFilteredDepots();
	const loading = useStoreState(state => state.kit.loading);

	useEffect(() => {
		//Se l'utente non ha i kit abilitati esco
		if (
			process.env.REACT_APP_KIT_ENABLED !== 'true' ||
			!iCan('CATALOGS') ||
			availableDepots.filter(d => d.id === 'FS01').length == 0
		)
			window.location.href = process.env.REACT_APP_DOMAIN;
	}, []);

	return (
		<Stack
			direction="column"
			justifyContent="flex-start"
			alignItems="flex-start"
			spacing={0}
			sx={{ minHeight: '100vh' }}
		>
			<Paper variant="stickyTop">
				<HeaderPage />
				{loading && <LinearProgress />}
			</Paper>
			<Box sx={{ width: '100%', padding: { xs: '20px 5px', md: '20px', sm: '20px 10px' } }}>
				<List />
			</Box>
		</Stack>
	);
};

export default KitUsers;
